import { ADMIN_URLS } from 'modules/featureFlags/constants';
import React from 'react';
import noop from 'utils/noop';
import ChangeLogModal from '../changeLogModal';
import EditModal from '../editModal';
import { FeatureFlagsTable as Table } from './FeatureFlagsTable';
import { ImportModal } from '../importModal';

// type Props = {
//   /** List of org admins with org id */
//   adminUsers: Dictionary<any>,
//   /** Current Change Log. */
//   changeLog: {},
//   /** List of feature flags. */
//   data: any[],
//   /** Object of formatted feature flags. */
//   dataObject: {},
//   /**
//    * Function to fetch change log of a feature flag.
//    * @param { String } featureName: The name of the feature flag.
//    * @returns { void }
//    */
//   fetchChangeLog: (featurFlag: any) => void,
//   /** If featureFlags are being fetched. */
//   isFetching: boolean,
//   /** If a change log is being fetched. */
//   isFetchingChangeLog: boolean,
//   /**
//    * Callback function when feature flag is saved.
//    * @param { Object } featureFlag: The feature flag to save.
//    * @param { String } comment: The comment of the change.
//    * @returns { void }
//    */
//   onSave: (featureFlag: {}, comment: string) => void,
//   /**
//    * Callback function when IDs imported to FF
//    */
//   onImport: () => void;
// };

export default class FeatureFlagsTable extends React.Component {
  static defaultProps = {
    data: [],
    dataObject: {},
    fetchChangeLog: noop,
    isFetching: false,
    onCloseChangeLog: noop,
    onOpenChangeLog: noop,
    onSave: noop,
    onImport: noop,
  };

  constructor(props) {
    super(props);
    this.state = {
      isChangeLogModalOpen: false,
      isEditModalOpen: false,
      isImportModalOpen: false,
      selectedFeatureFlag: {},
      featureFlags: [],
    };
  }

  /**
   * Callback function when edit modal is closed.
   */
  handleClose = () => {
    this.setState({ isEditModalOpen: false });
  };

  /**
   * Callback function when change log modal is closed.
   */
  handleCloseChangeLog = () => {
    this.setState({ isChangeLogModalOpen: false });
  };

  handleCloseImportModal = (didImport) => {
    this.setState({ isImportModalOpen: false });
    if (didImport) this.props.onImport();
  };

  /**
   * Callback function when feature flag is saved.
   *
   * ```
   * onSave(featureFlag, comment)
   * ```
   * @param { Object } featureFlag: The feature flag to save.
   * @param { String } comment: The comment of the change.
   * @returns { void }
   */
  handleSave = (featureFlag, comment) => {
    this.props.onSave(featureFlag, comment);
  };

  handleImport = (selectedFeatureFlag) => {
    this.setState({ selectedFeatureFlag, isImportModalOpen: true });
  };

  /**
   * handleEditRow
   * Callback function when row is being edited.
   */
  handleEditRow = (selectedFeatureFlag) => {
    this.setState({ selectedFeatureFlag, isEditModalOpen: true });
  };

  /**
   * handleViewChangeLog
   * Callback function when changelog modal is opened.
   */
  handleViewChangeLog = (selectedFeatureFlag) => {
    this.props.fetchChangeLog(selectedFeatureFlag.feature);
    this.setState({ selectedFeatureFlag, isChangeLogModalOpen: true });
  };

  /**
   * getFeatureFlagSettings
   * Gets the settings object from the feature flag object.
   * @param { Object } featureFlag: The feature flag object.
   * @returns { Object } The settings object.
   */
  getFeatureFlagSettings = (featureFlag = {}) => {
    const { dataObject } = this.props;
    return dataObject[featureFlag] || {};
  };

  getEnvironment = () => {
    switch (window.location.host.toLowerCase()) {
      case ADMIN_URLS.productionEU:
        return 'PRODUCTION-EU';

      case ADMIN_URLS.stagingEU:
        return 'STAGING-EU';

      case ADMIN_URLS.production:
        return 'PRODUCTION-US';

      case ADMIN_URLS.staging:
        return 'STAGING-US';

      default:
        return 'DEVELOPMENT';
    }
  };

  static getDerivedStateFromProps({ data }, { prevData }) {
    if (data !== prevData) {
      return { featureFlags: data.map((item) => ({ ...item, id: item.feature })), prevData: data };
    }
    return {};
  }

  render() {
    const { adminUsers, changeLog, fetchChangeLog, isFetching, isFetchingChangeLog } = this.props;
    const {
      selectedFeatureFlag,
      isEditModalOpen,
      isChangeLogModalOpen,
      isImportModalOpen,
      featureFlags,
    } = this.state;
    const { feature, isFractional } = selectedFeatureFlag;
    const {
      enabledGlobally,
      enabledOrgIds,
      enabledProjectIds,
      disabledOrgIds,
      disabledProjectIds,
      globalFraction,
      orgIdFractions,
      projectIdFractions,
    } = this.getFeatureFlagSettings(feature);

    return (
      <>
        {isImportModalOpen && (
          <ImportModal
            env={this.getEnvironment()}
            featureFlag={selectedFeatureFlag}
            onClose={this.handleCloseImportModal}
          />
        )}
        {isChangeLogModalOpen && (
          <ChangeLogModal
            changeLog={changeLog}
            featureFlag={selectedFeatureFlag}
            fetchChangeLog={fetchChangeLog}
            isFetching={isFetchingChangeLog}
            open={isChangeLogModalOpen}
            onClose={this.handleCloseChangeLog}
          />
        )}
        {isEditModalOpen && (
          <EditModal
            adminUsers={adminUsers}
            enabledGlobally={enabledGlobally}
            enabledOrgIds={enabledOrgIds}
            enabledProjectIds={enabledProjectIds}
            env={this.getEnvironment()}
            disabledOrgIds={disabledOrgIds}
            disabledProjectIds={disabledProjectIds}
            featureFlag={selectedFeatureFlag}
            globalFraction={globalFraction}
            header={feature}
            isFractional={isFractional}
            onClose={this.handleClose}
            onSave={this.handleSave}
            orgIdFractions={orgIdFractions}
            projectIdFractions={projectIdFractions}
          />
        )}
        {!isFetching && (
          <Table
            featureFlags={featureFlags}
            onOpenEdit={this.handleEditRow}
            onOpenChangeLog={this.handleViewChangeLog}
            onImport={this.handleImport}
          />
        )}
      </>
    );
  }
}
